import type { RationaleStrings, SkillLevel, SkillSource } from "@/modules/lernpfad/engine"
import type { Localizer } from "./localize"

/**
 * Build the engine's `RationaleStrings` from a localizer.
 *
 * The seam that keeps `engine/rationale.ts` free of the i18n layer: the engine
 * declares which words it needs, this module supplies them in the reader's
 * language, and neither imports the other's internals.
 */
export function rationaleStringsFor(localizer: Localizer): RationaleStrings {
    const { t } = localizer

    const source = {
        stellenprofil: t("rat.src.stellenprofil"),
        lernhistorie: t("rat.src.lernhistorie"),
        cv: t("rat.src.cv"),
        mag: t("rat.src.mag"),
        selbsteinschaetzung: t("rat.src.selbsteinschaetzung"),
    } satisfies Record<SkillSource, string>

    const level = {
        0: localizer.level(0),
        1: localizer.level(1),
        2: localizer.level(2),
        3: localizer.level(3),
        4: localizer.level(4),
    } satisfies Record<SkillLevel, string>

    return {
        mandatory: t("rat.mandatory"),
        dueBy: t("rat.dueBy"),
        prerequisite: t("rat.prerequisite"),
        closesGoal: t("rat.closesGoal"),
        closesAlso: t("rat.closesAlso"),
        closes: t("rat.closes"),
        fallback: t("rat.fallback"),
        source,
        level,
        formatDate: localizer.date,
        obligation: (id, fallback) => ({
            label: localizer.obligationLabel(id, fallback.label),
            basis: localizer.obligationBasis(id, fallback.basis),
        }),
        skill: localizer.skill,
    }
}
